<div class="container-fluid p-0">
  <div
    class="step d-flex flex-column align-items-center"
    *ngFor="let item of steps; let index = index"
    [ngClass]="{ finished: item.czySkonczony, 'border-success bg-white': item.czyAktualny }"
  >
    <div
      class="step__index d-flex justify-content-center align-items-center"
      [ngClass]="{ accomplished: item.czySkonczony, active: item.czyAktualny }"
    >
      <span class="text-white">{{ index + 1 }}</span>
    </div>
    <span class="title mt-2 text-center" [ngClass]="{ active: item.czyAktualny || item.czySkonczony }">
      {{ item.nazwaStatusu }}
    </span>
    <app-icon *ngIf="item.czySkonczony" class="mt-2 text-success" name="check"></app-icon>
  </div>
</div>
